import {Box} from '@mui/material';
import ArrTransferList from '../../../components/common/arr-transfer-list/ArrTransferList';
import {useState} from 'react';
const availableAssignedList = [
  {id: 1, label: 'Alice Johnson'},
  {id: 2, label: 'Bob Smith'},
  {id: 3, label: 'Charlie Brown'},
  {id: 4, label: 'Diana Prince'},
  {id: 5, label: 'Ethan Hunt'},
  {id: 6, label: 'Fiona Gallagher'},
  {
    id: 7,
    label: 'George Martin Martin Martin MartinMartinMartinMartin MartinMartin',
  },
  {id: 8, label: 'Hannah Lee'},
  {id: 9, label: 'Ian Wright'},
  {id: 10, label: 'Julia Roberts'},
  {id: 11, label: 'Kevin Durant'},
  {id: 12, label: 'Lara Croft'},
  {id: 13, label: 'Mike Tyson'},
  {id: 14, label: 'Nina Simone'},
  {id: 15, label: 'Oscar Wilde'},
  {id: 16, label: 'Paula Abdul'},
  {id: 17, label: 'Quentin Blake'},
  {id: 18, label: 'Rachel Green'},
  {id: 19, label: 'Steve Jobs'},
  {id: 20, label: 'Tina Turner'},
  {id: 21, label: 'Uma Thurman'},
  {id: 22, label: 'Victor Hugo'},
  {id: 23, label: 'Wendy Darling'},
  {id: 24, label: 'Xander Harris'},
  {id: 25, label: 'Yara Shahidi'},
  {id: 26, label: 'Zack Morris'},
  {id: 27, label: 'Amber Heard'},
  {id: 28, label: 'Brian Cox'},
  {id: 29, label: 'Catherine Zeta'},
  {id: 30, label: 'Daniel Craig'},
];

const selectedAssignedListInitial = [
  {id: 9, label: 'Ian Wright'},
  {id: 14, label: 'Nina Simone'},
  {id: 15, label: 'Oscar Wilde'},
];

export type KeyValue = {
  id: number;
  label: string;
};
const TransferListDemo: React.FC = () => {
  const [selectedAssignedList, setSelectedAssignedList] = useState<KeyValue[]>(
    selectedAssignedListInitial
  );

  const handleAssignChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    user: KeyValue
  ) => {
    const isChecked = event.target.checked;

    setSelectedAssignedList((prev) => {
      if (isChecked) {
        const alreadyExists = prev.some((u) => u.id === user.id);
        return alreadyExists ? prev : [...prev, user];
      } else {
        return prev.filter((u) => u.id !== user.id);
      }
    });
  };

  return (
    <Box className="textfield-demo" style={{display: 'flex', gap: '10px'}}>
      <ArrTransferList
        showCheckbox={true}
        selectedList={selectedAssignedList}
        displayedList={availableAssignedList}
        onChange={() => {
          console.log();
        }}
        title={'Transfer List no change'}
        checkboxDataTestId="transfer-list-demo-no-change-checkbox"
      />

      <ArrTransferList
        showCheckbox={true}
        selectedList={selectedAssignedList}
        displayedList={availableAssignedList}
        onChange={handleAssignChange}
        title={'Transfer List with onChange'}
        checkboxDataTestId="transfer-list-demo-with-on-change-checkbox"
      />

      <ArrTransferList
        showCheckbox={true}
        selectedList={[]}
        displayedList={availableAssignedList}
        onChange={handleAssignChange}
        title={'Transfer List Disabled'}
        disable={true}
        checkboxDataTestId="transfer-list-demo-disabled-checkbox"
      />

      <ArrTransferList
        showCheckbox={true}
        selectedList={[]}
        displayedList={[]}
        onChange={handleAssignChange}
        title={'Transfer List Empty'}
        checkboxDataTestId="transfer-list-demo-empty-checkbox"
      />
    </Box>
  );
};
export default TransferListDemo;
